import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { PINK_GIFT } from '../../../config/constants/images';
import { BRAND_WOWCHER } from '../../../config/setup/setup';
import {
  GIFT_BANNER_SUBTEXT,
  GIFT_BANNER_TITLE,
} from '../../../config/text/text';
import ThemeContext from '../../../providers/ThemeProvider';

export const GiftBanner = ({ banners }) => {
  const theme = useContext(ThemeContext);
  const defaultBanner = {
    'background-color': theme.colors.giftBannerBackground,
    'banner-image': null,
    'banner-mobile-image': null,
    'text-color': theme.colors.white,
  };
  const [banner, setBanner] = useState(defaultBanner);

  useEffect(() => {
    if (banners) {
      const bannerFromConfig = banners.find(
        (configBanner) => configBanner.live,
      );
      if (bannerFromConfig) {
        setBanner(bannerFromConfig);
      }
    }
  }, [banners]);

  return (
    <div
      className={
        process.env.NEXT_PUBLIC_BRAND === BRAND_WOWCHER
          ? 'giftbanner-wowcher-container'
          : 'giftbanner-container'
      }
      data-testid="giftbanner"
    >
      <div className="container">
        <div className="row">
          <div className="col">
            <div
              className={
                process.env.NEXT_PUBLIC_BRAND === BRAND_WOWCHER
                  ? 'giftbanner-wowcher'
                  : 'giftbanner'
              }
            >
              <h3 className="giftfinder-text">{GIFT_BANNER_TITLE}</h3>
              <p className="giftfinder-subtext">{GIFT_BANNER_SUBTEXT}</p>
            </div>
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .giftbanner-wowcher-container {
            background-color: ${banner['background-color']};
            background-image: url(${PINK_GIFT});
            background-position: right;
            background-size: contain;
            background-repeat: no-repeat;
          }

          .giftbanner-container {
            background-color: ${banner['background-color']};
            background-image: url(${banner['banner-mobile-image']});
            background-position: right;
            background-repeat: no-repeat;
          }
          .giftfinder-text {
            color: ${banner['text-color']};
            font-size: 26px;
            font-family: Helvetica, Arial, sans-serif;
            font-weight: bold;
            line-height: 26px;
            margin-bottom: 0;
            padding: 10px 0 5px 10px;
            text-transform: uppercase;
          }
          .giftfinder-subtext {
            color: ${banner['text-color']};
            font-size: 16px;
            line-height: 20px;
            margin-bottom: 0;
            padding: 0px 0 5px 10px;
            text-transform: capitalize;
          }
          @media (min-width: ${theme.breakpoints.smUp}) {
            .giftbanner-wowcher-container {
              background-image: url(${PINK_GIFT}), url(${PINK_GIFT});
              background-size: 150px;
              background-position: 5%, 95%;
              background-repeat: no-repeat;
            }
            .giftbanner-wowcher {
              text-align: center;
            }
            .giftfinder-text {
              padding: 10px 0 5px 0;
            }
            .giftfinder-subtext {
              display: block;
              padding: 0 0 12px 0;
            }
          }
          @media (min-width: ${theme.breakpoints.mdUp}) {
            .giftbanner-wowcher-container {
              background-position: 20%, 80%;
              background-size: 130px;
            }
            .giftbanner-container {
              background-image: url(${banner['banner-image']});
            }
          }
          @media (min-width: ${theme.breakpoints.lgUp}) {
            .giftbanner-wowcher-container {
              background-position: 30%, 70%;
              background-size: 140px;
            }
            .giftfinder-text {
              padding: 15px 0 8px 0;
            }
            .giftfinder-subtext {
              padding: 0 0 20px 0;
            }
          }
        `}
      </style>
    </div>
  );
};

GiftBanner.propTypes = {
  banners: PropTypes.array,
};
